import {NgModule} from '@angular/core';
import {InputComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SimpleMaskModule} from '@initru/ngx-ion-simple-mask';
import {DirectivesModule} from '../../../core/directives/directives.module';

@NgModule({
    imports: [
        IonicModule,
        NgStyle,
        NgClass,
        NgIf,
        SimpleMaskModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule
    ],
  exports: [
    InputComponent
  ],
  declarations: [InputComponent],
  providers: [],
})
export class InputComponentModule {
}
